import { useProject } from "@/api/project";
import { blue } from "@/utils/Colors";
import { Box, LinearProgress } from "@mui/material";
import List from "@mui/material/List";
import NavItemLvlThree from "./NavItemLvlThree";

interface SideBarProjectContentProps {
  projectId: string;
  openSections: Set<string>;
}

function SideBarProjectContent(props: Readonly<SideBarProjectContentProps>) {
  const projectQuery = useProject({
    projectId: props.projectId,
  });

  if (projectQuery.isPending || projectQuery.isError) {
    return <LinearProgress />;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", paddingLeft: 2.25 }}>
      <List
        component="div"
        disablePadding
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingX: 2,
          gap: 0.5,
          borderLeft: 1,
          borderLeftColor: blue[300],
        }}
      >
        {projectQuery?.data?.requests.map((request) => (
          <NavItemLvlThree
            key={request.id}
            request={request}
            projectId={props.projectId}
          />
        ))}
      </List>
    </Box>
  );
}

export default SideBarProjectContent;
